import InStackDemandSelectorActions from './InStackDemandSelector.actions';

const initialState = {
  skillsIds: [],
  stackDemandIds: []
};

function InStackDemandSelectorReducer (state = initialState, action) {
  const { type = '', payload = null } = { ...action };
  switch (type) {
    case InStackDemandSelectorActions.SET_SELECTED_SKILLS:
      return { ...state, ...payload };
    default:
      return state;
  }
}

export default InStackDemandSelectorReducer;
